<template>
  <div>
    <el-row>
      <el-col :span="1" :offset="23">
        <el-button type="primary" size="mini" @click="changeGantt">
          {{ changeName }}</el-button
        >
      </el-col>
    </el-row>
    <gantt-elastic
      v-if="showGantt"
      :options="options"
      :tasks="tasks"
      @tasks-changed="tasksUpdate"
      @options-changed="optionsUpdate"
      @dynamic-style-changed="styleUpdate"
    >
      <!-- <gantt-header slot="header"></gantt-header> -->
    </gantt-elastic>
  </div>
</template>

<style>
</style>

<script>
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import dayjs from "dayjs";
import { GetZjwjPlanDetail } from "@/setAxios";
// just helper to get current dates
function getDate(hours) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const timeStamp = new Date(
    currentYear,
    currentMonth,
    currentDay,
    0,
    0,
    0
  ).getTime();
  return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
}
let options = {
  taskMapping: {
    progress: "percent",
  },
  maxRows: 100,
  maxHeight: 500,
  title: {
    label: "Your project title as html (link or whatever...)",
    html: false,
  },
  row: {
    height: 40,
  },
  calendar: {
    hour: {
      display: true,
    },
  },
  chart: {
    progress: {
      bar: false,
    },
    expander: {
      display: true,
    },
  },
  taskList: {
    expander: {
      straight: false,
    },
    columns: [
      {
        id: 2,
        label: "任务名称",
        value: "label",
        width: 100,
        expander: true,
        html: true,
      },
      {
        id: 3,
        label: "责任人",
        value: "fzr",
        width: 130,
      },
      {
        id: 3,
        label: "审核人",
        value: "shr",
        width: 78,
      },
      {
        id: 4,
        label: "计划工作时常",
        value: "jhsc",
        width: 100,
      },
      {
        id: 5,
        label: "实际工作时长",
        value: "sjsc",
        width: 100,
      },
    ],
  },
  locale: {
    name: "en",
    Now: "Now",
    "X-Scale": "Zoom-X",
    "Y-Scale": "Zoom-Y",
    "Task list width": "Task list",
    "Before/After": "Expand",
    "Display task list": "Task list",
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    months: [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ],
  },
};

export default {
  name: "Gantt",
  components: {
    GanttElastic,
    GanttHeader,
  },
  data() {
    return {
      changeName: "切换实际",
      showGantt: false,
      tasks: [],
      options,
      dynamicStyle: {},
      lastId: 16,
    };
  },
  props: {
    gantData: {},
  },
  watch: {
    gantData: function (newValue, oldValue) {
      this.GetZjwjPlanDetail(1);
    },
  },
  mounted() {
    let that = this;
    if (this.gantData) {
      this.GetZjwjPlanDetail(1);
    }
  },
  methods: {
    changeGantt() {
      if (this.changeName === "切换实际") {
        this.changeName = "切换计划";
        this.GetZjwjPlanDetail(2);
      } else {
        this.changeName = "切换实际";
        this.GetZjwjPlanDetail(1);
      }
    },
    async GetZjwjPlanDetail(type) {
      let params = {
        planid: this.gantData.id,
        searchword: "",
      };
      let res = await GetZjwjPlanDetail({ params });
      let list = res.Data;
      let tasksList = [];
      list.forEach((ele) => {
        //   parentId为0 时不能添加到temp中
        var temp = {
          id: ele.zwpd01,
          label: ele.zwpd04,
          fzr: (function () {
            let newArr = [];
            ele.fzList.forEach((ele2) => {
              newArr.push(ele2.user04);
            });
            return newArr.join(",");
          })(),
          shr: (function () {
            let newArr = [];
            ele.shList.forEach((ele2) => {
              newArr.push(ele2.user04);
            });
            return newArr.join(",");
          })(),
          jhsc: ele.planDays,
          sjsc: ele.trueDays,
          start: type === 1 ? ele.zwpd05 : ele.zwpd09 ? ele.zwpd09 : new Date(),
          end: type === 1 ? ele.zwpd06 : ele.zwpd10 ? ele.zwpd10 : new Date(),
          type: "project",
          percent: (ele.trueDays / ele.planDays) * 100,
          style: {
            base: {
              fill: (function () {
                switch (ele.state) {
                  case "已完成正常":
                    return "rgb(153, 51, 255)";
                    break;
                  case "进行中正常":
                    return "rgb(18, 169, 174)";
                    break;
                  case "已完成延期":
                    return "rgb(255, 153, 0)";
                    break;
                  case "进行中延期":
                    return "rgb(255, 0, 0)";
                    break;
                  case "未启动正常":
                    return "rgb(255,255,255)";
                    break;
                  case "未启动延期":
                    return "rgb(107, 107, 107)";
                    break;
                }
              })(),
              stroke: "#eee",
            },
          },
        };
        if (ele.zwpd15 !== 0) {
          temp.parentId = ele.zwpd15;
        }
        tasksList.push(temp);
      });
      this.showGantt = true;
      this.tasks = tasksList;
    },
    initGantt() {},
    tasksUpdate(tasks) {
      this.tasks = tasks;
    },
    optionsUpdate(options) {
      this.options = options;
    },
    styleUpdate(style) {
      this.dynamicStyle = style;
    },
  },
};
</script>